import moment from 'moment';
import {
  ApproveReimbursementFilterType,
  CreateMarketActivityFilterType,
  EmployeeNameType,
  FilterType,
  LeaveDetails,
  PaginationType,
  SelectOptionType,
  SetMarketActivityFilterType,
  TrackLocationFilterType,
  ViewTaskFilterType,
} from './Types';
export const TABLE_SORT_AESC = 'AESC';
export const TABLE_SORT_DESC = 'DESC';

export const KYC_DOCUMENT_TYPE = {
  AADHAR: 'Aadhaar Card',
  PAN_CARD: 'Pancard',
  EDUCATION: 'Educational Certificate',
  BANK: 'Bank Document',
};

export const LOGIN_STATUS = {
  INITIATED: 'initiated',
  AUTHENTICATED: 'authenticated',
  NO_AUTHENTICATED: 'no-authenticated',
};
export const CLICK_ACTIONS = {
  APPROVE: 'approve',
  REJECT: 'reject',
  HOLD: 'hold',
  VERIFICATION_PENDING: 'verification_pending',
  ASSIGN_GRID: 'assign_grid',
  CLAIM_SEARCH: 'claim_search',
  REFRESH_LIST: 'refresh_list',
  KYC_UPLOAD: 'kyc_upload',
  KYC_APPROVE: 'kyc_approve',
  NAVIGATE_TO_ASSIGN_GRID: 'navigate_assign_grid',
  KYC_VIEW_DETAILS: 'kyc_view_details',
  NO_ACTION: 'no_action',
  VIEW_TASK: 'view_task',
  CLOSE_VIEW_TASK: 'close_view_task',
  VIEW_LEAD: 'view_lead',
  CLOSE_VIEW_LEAD: 'close_view_lead',
  SHOW_TRACK_LOCATION: 'show_track_location',
  APPLY_REIMBURSEMENT: 'apply_reimbursement',
  APPROVE_REIMBURSEMENT: 'apply_reimbursement',
  SHOW_APPLY_REIMBURSEMENT: 'show_apply_reimbursement',
  SET_PRIMARY_ASSIGNEE: 'set_primary',
  REMOVE_ASSIGNEE: 'remove',
  UPDATE_MARKETING_ACTIVITY: 'update_marketing_activity',
  REVIEW_MARKETING_ACTIVITY: 'review_marketing_activity',
  VIEW_REMUNERATION: 'view_remuneration',
  ATTENDEES_CHECK_IN_LIST: 'attendeed_check_in_list',
  ATTENDEES_CHECK_OUT_LIST: 'attendeed_check_out_list',
  VIEW_ROLE_DETAILS: 'role_details',
  EDIT_ROLES: 'edit_role',
  REIMBURSEMENT_SUCCESS_MODAL: 'reimbursement_success_nodal',
};

export const TASK_ACTION = {
  VIEW: 'view',
  CREATE: 'create',
  ASSIGN: 'assign',
};

export const LEAD_STATUS_OPTIONS = {
  NEW: 14,
  FOLLOW_UP: 16,
  UNQUALIFIED: 17,
  CLOSE: 18,
};
export const METHOD = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'delete',
};
export const PAGE_SIZE = {
  TWENTY: 20,
  FIFTY: 50,
  HUNDRED: 100,
};
export const DEFAULT_PAGE_SIZE = PAGE_SIZE.TWENTY;

export const REGISTRATION_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  ACTIVE: 3,
  REJECTED: 4,
};

export const OTP_STATUS = {
  REQUESTED: 5,
  VERIFIED: 6,
  CLOSED: 7,
  EXPIRED: 8,
};

export const KYC_DOCUMENT_STATUS = {
  YET_TO_UPLOAD: 1,
  UPLOADED: 2,
  APPROVED: 3,
  REJECT: 4,
};

export const IIB_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECT: 3,
  HOLD: 4,
};

export const KYC_DOCUMENT_APPROVAL_STATUS = {
  YET_TO_UPLOAD: {
    code: 1,
    value: 'Yet to Upload',
  },
  UPLOADED: {
    code: 2,
    value: 'Uploaded',
  },
  APPROVED: {
    code: 3,
    value: 'Approved',
  },
  REJECTED: {
    code: 4,
    value: 'Rejected',
  },
};

export const COMPLETED_STATUS = {
  COMPLETED: 'Completed',
  NOT_COMPLETED: 'Not Completed',
};

export const API_STATUS = {
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};
export const API_RESPONSE_CODE = {
  FAIL: '1',
  SUCCESS: '0',
};

export const STORAGE_KEY = {
  AUTH_DATA: 'app-auth',
  ITUS: 'app-itus',
  TOKEN_EXPIRE: 'token_expire',
  POWERBI: 'powerbi',
};
export const ONBOARDING_TYPE = {
  REGISTRATION_APPROVAL: 'registration_approval',
  KYC_VERIFICATION: 'kyc_verification',
};
export const EMP_DETAILS_TYPE = {
  INFO: 'EMP_INFORMATION',
  ROLE: 'ROLE_MANAGEMENT',
  DATA: 'EMP_DATA',
};

export const DEFAULT_OPTION: SelectOptionType = { label: 'Select', value: '' };
export const DEFAULT_OPTION_ALL: SelectOptionType = { label: 'All', value: '' };
export const DEFAULT_OPTION_TRACK_COMPLAINT: SelectOptionType = {
  label: '',
  value: '',
};
export const NO_DATA_OPTION: SelectOptionType = { value: '', label: 'No data' };
export const DEFAULT_OPTION_LOCATION: SelectOptionType = {
  label: 'All',
  value: '',
};
export const DEFAULT_OPTION_LOCATION_SET_TARGET: SelectOptionType = {
  label: 'All',
  value: 'All',
};
export const LEAD_TYPE_OPTIONS = [
  { value: 1, label: 'Social Media' },
  { value: 2, label: 'Call Centre' },
  { value: 3, label: 'Marketing Campaign' },
  { value: 4, label: 'iAgri' },
];

export const SIDE_MENU_STATUS = {
  OPEN: 1,
  CLOSE: 2,
  OPPOSITE: 3,
};

export const TARGET_FILTER_INIT: FilterType = {
  season: null,
  year: null,
  zone: 'All',
  state: 'All',
  district: 'All',
  village: 'All',
  grid: 'All',
  target: null,
  product: '0',
};

export const LIST_VIEW_ITEM = {
  LIST_ITEMS: 'list-items',
  VIEW_ITEM: 'view-item',
};

export const ROLE_CEO_BDO_CGO = [1, 2, 3];
export const ROLE_ZH = 4;
export const ROLE_SH = 5;
export const ROLE_POSP_M = 6;
export const ROLE_POSP = 7;
export const TASK_IEC = 4;
export const VP_PATNERSHIP = 24;
export const KEY_ACCOUNT_MANAGER = 25;
export const ROLE_OPERATIONAL_ADMIN = 41;
export const ROLE_KSHEMA_POSP = 40;

export const APPLY_REIMBURSEMENT_ALLOWED_ROLES = [2, 3, 4, 5, 6, 8, 9];
export const APPLY_REIMBURSEMENT_ALLOWED_ROLES_OMDC = [
  2, 3, 4, 5, 6, 8, 9, 12, 18, 19, 20, 23, 24, 25, 27, 28,
];
export const APPROVE_REIMBURSEMENT_ALLOWED_ROLES = [
  1, 2, 3, 4, 5, 6, 8, 9, 24, 25,
];
export const APPROVE_REIMBURSEMENT_ALLOWED_ROLES_OMDC = [
  1, 2, 3, 4, 5, 6, 8, 9, 12, 18, 19, 20, 23, 24, 25, 27, 28,
];

export const trackLocationStatusOption: SelectOptionType[] = [
  { label: 'Logged', value: 'Logged' },
  { label: 'Not-Logged', value: 'Not-Logged' },
];

export const assignGridRoleOption: SelectOptionType[] = [
  { label: 'All', value: '' },
  { label: 'POSP', value: 'POSP' },
  { label: 'POSPM', value: 'POSPM' },
  { label: 'RURAL ASSOCIATE', value: 'Rural Associate' },
];
export const claimSearchOption = [
  { label: 'Claim ID', value: 'claimID' },
  { label: 'Policy ID', value: 'policyID' },
  { label: 'Mobile Number', value: 'mobileNo' },
  { label: 'Farmer ID', value: 'farmerID' },
];

export const assignGridStatusOption: SelectOptionType[] = [
  { label: 'All', value: '' },
  { label: 'Un-assigned', value: 'U' },
  { label: 'Assigned', value: 'A' },
];
export const I_FRAMES_URL = {
  ICE_OPS: process.env.REACT_APP_ICE_OPS ?? '',
  CHM_OPS: process.env.REACT_APP_CHM_OPS ?? '',
  REPORT:
    'https://app.powerbi.com/reportEmbed?reportId=b7e424be-a1bd-4be9-be47-522110cbcb31&autoAuth=true&ctid=225a33a3-a252-427b-a09a-5ae946b50ce4',
};
export const POWERBI_IDS = {
  groupId: process.env.REACT_APP_POWERBI_GROUP_ID ?? '',
  reportId: process.env.REACT_APP_POWERBI_REPORT_ID ?? '',
  homeReportId: process.env.REACT_APP_POWERBI_HOME_KPI_ID ?? '',
  dashboardId: process.env.REACT_APP_POWERBI_DASHBOARD_ID ?? '',
  topPerformersId: process.env.REACT_APP_POWERBI_TOP_PERFORMERS_ID ?? '',
};
export const MARKET_ACTIVITY_FILTER_INIT: CreateMarketActivityFilterType = {
  season: null,
  year: null,
  zone: null,
  state: null,
  district: null,
  village: null,
  pincode: null,
  activityId: null,
};
export const REVIEW_MARKET_ACTIVITY_FILTER_INIT: SetMarketActivityFilterType = {
  season: null,
  year: null,
  zone: 'All',
  state: 'All',
  district: 'All',
  village: 'All',
  pincode: null,
  activityId: null,
  status: 'All',
};
export const DATE_FORMAT = {
  DD_MM_YYYY: 'DD-MM-YYYY',
  YYYY_MM_DD: 'YYYY-MM-DD',
  DD_MM_YYYY_hh_mm_A: 'DD-MM-YYYY hh:mm A',
};

export const BlankPagination: PaginationType = {
  currentPage: 1,
  pageSize: 0,
  totalPages: 1,
  totalItems: 0,
  fromItem: 0,
  toItem: 0,
};
export const defaultTabOption = [{ label: 'Tab1', value: 1 }];

export const LeaveType = {
  APPROVE_LEAVE: 'approve_leave',
  LEAVE_HISTORY: 'leave_history',
};

export const leaveDetailsBlank: LeaveDetails = {
  lastName: '',
  zohoReferenceId: null,
  city: null,
  endDate: '',
  emailId: '',
  candidateUniqueId: null,
  cityName: '',
  zone: null,
  stateName: '',
  requestedSource: null,
  state: null,
  zoneName: '',
  pincode: null,
  districtName: '',
  roleId: null,
  photo: '',
  firstName: '',
  employeeUniqueId: null,
  district: null,
  roleName: '',
  location: null,
  leaveTypeId: null,
  leaveStatus: '',
  candidateId: null,
  requestStatus: null,
  startDate: '',
  leaveRequestId: null,
  leaveTypeName: '',
  comments: '',
  lastModifiedBy: '',
  zohoLeaveTypeId: '',
  reasonForLeave: '',
  reportingManagerName: '',
  reportingManagerId: null,
  reportingManagerRole: '',
  noOfLeaves: null,
  mobileNumber: '',
  createdOn: '',
  leaveDays: 0,
  approver: '',
  approvedDate: null,
};

export const ATTENDEES_STATUS = {
  MARKED: 19,
  APPROVED: 20,
  REJECTED: 21,
  SYSTEM_APPROVED: 25,
};

export const ATTENDEES_LOCATIONS = {
  ATTENDANCE_MARKED: 'attendance-marked',
  ASSIGNED_LOCATION: 'assigned-location',
};

export const LEAVE_STATUSES = {
  PENDING: 22,
  APPROVE: 23,
  REJECT: 24,
};

export const VIEW_ATTENDEES = {
  ACTION_REQUIRED: 19,
};
export const LEAVE_PAGE_TYPE = {
  LEAVE_HISTORY: 'leave-history',
  APPROVE_LEAVE: 'approve-leave',
};
export const DefaultClaimType = {
  Accommodation: false,
  Food: false,
  Miscellaneous: false,
  Travel: true,
};
export const REIMBURSEMENT_CLIAM_TYPES = {
  Travel: 24,
  Food: 25,
  Accommodation: 26,
  Miscellaneous: 27,
};
export type ReimbursementClaimType = keyof typeof REIMBURSEMENT_CLIAM_TYPES;

export const REIMBURSEMENT_STATUS_TYPES = {
  REJECT: 28,
  APPROVED: 27,
  APPROVAL_PENDING: 26,
};

export const foodFormDataBlank = {
  reimbursementTypeId: REIMBURSEMENT_CLIAM_TYPES?.Food,
  locationA: '',
  totalExpenses: '',
  comments: '',
  claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
};

export const travelFormDataBlank = {
  reimbursementTypeId: REIMBURSEMENT_CLIAM_TYPES?.Travel,
  locationA: '',
  locationB: '',
  totalDistance: '',
  totalExpenses: '',
  reason: '',
  comments: '',
  claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
};

export const miscellaneousDataBlank = {
  reimbursementTypeId: REIMBURSEMENT_CLIAM_TYPES?.Miscellaneous,
  claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
  locationA: '',
  totalExpenses: '',
  comments: '',
};

export const accommodationDataBlank = {
  reimbursementTypeId: REIMBURSEMENT_CLIAM_TYPES?.Accommodation,
  locationA: '',
  totalExpenses: '',
  reason: '',
  comments: '',
  district: '',
  state: '',
  city: '',
  zone: '',
  claimFromDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
  claimToDate: moment(new Date()).format('DD-MM-YYYY H:mm'),
  pincode: '',
};

export const APPLY_REIMBURSEMENT_TYPES = {
  NEW_TASK: 'new_task',
  ALREADY_EXISTED_TASK: 'already_existed_task',
};

export const TEXT_ONLY_REGEX = /^[a-zA-Z\s.]+$/;
export const defaultViewTaskFilter: ViewTaskFilterType = {
  taskId: '',
  taskName: DEFAULT_OPTION,
  source: DEFAULT_OPTION,
  assignedTo: DEFAULT_OPTION,
  status: DEFAULT_OPTION,
  fromDate: undefined,
  toDate: undefined,
  zone: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  customTaskName: '',
};
export const blankSelectedEmployee: EmployeeNameType = {
  employeeName: '',
  roleName: '',
  roleId: '',
  mobileNumber: '',
  employeeUniqueId: '',
  candidateId: '',
};
export const blankLocation = {
  sl: '',
  pincode: '',
  location: '',
  district: '',
  state: null,
  city: '',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: '',
  zones: '',
};
export const blankLocationData = {
  sl: '',
  pincode: '',
  location: '',
  district: 'All',
  state: 'All',
  city: 'All',
  statecode: '',
  statecd: '',
  pincodecol: '',
  did: '',
  zone: 'All',
  zones: '',
};
export const mockVideos = [
  {
    name: 'Explore-FA-Hindi',
    url: 'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/FAHINDI_FA%20Hindi%20final%20draft.mp4?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
    id: 1,
    thumbnail:
      'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/Screenshot%20%281%29.png',
    createdOn: '2024-03-13T11:23:11.789',
  },
];

export const welcomeVideosMockData = {
  videos: [
    {
      createdOn: '2024-03-13T11:23:11.789+00:00',
      bannerId: 1,
      bannerOrder: 1,
      bannerThumbnail: 'ss',
      bannerTitle: 'Explore-FA-Hindi',
      bannerUrl:
        'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/FAHINDI_FA%20Hindi%20final%20draft.mp4?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
    },
  ],
  status: 'succeeded',
};

export const mockLatestUpdates = [
  {
    latestUpdateDescription: 'Update 1',
    latestUpdateId: 1,
    createdOn: '2024-03-13T11:23:11.789',
  },
];

export const latestUpdatesMockData = {
  allList: {
    updates: [
      {
        latestUpdateId: 4,
        latestUpdateDescription: 'test',
        createdOn: '2024-09-09 10:16:00.115',
      },
    ],
    pagination: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 1,
      totalItems: 1,
      fromItem: 1,
      toItem: 2,
    },
  },
  allListAPIStatus: 'succeeded',
};

export const mockBanners = [
  {
    url: 'https://example.com/images/1.jpg',
    id: 1,
  },
];

export const knowledgeCenterMockData = {
  media: {
    images: [],
    pdf: [
      {
        knowledgeCenterTitle: 'Terms And Conditions',
        createdOn: '2024-09-06 17:20:37.164',
        knowledgeCenterId: 26,
        knowledgeCenterTypeId: 1,
        knowledgeCenterOrder: 1,
        knowledgeCenterTypeName: 'Insurance',
        fileType: 'pdf',
        knowledgeCenterUrl:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/1_tc.pdf?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        knowledgeCenterThumbnail:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/1_tc.jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
      },
    ],
    documents: [],
    videos: [
      {
        createdOn: '2024-09-06 17:22:02.669',
        knowledgeCenterId: 28,
        knowledgeCenterTitle: 'Terms And Conditions (Part 1)',
        knowledgeCenterUrl:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/1_1_SampleVideo.mp4?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
        fileType: 'videos',
        knowledgeCenterTypeId: 1,
        knowledgeCenterOrder: 1,
        knowledgeCenterTypeName: 'Insurance',
        knowledgeCenterThumbnail:
          'https://sa4fieldassistdev.blob.core.windows.net/fa-datablobs/1_tc.jpg?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2024-10-31T13:23:55Z&st=2024-05-03T05:23:55Z&spr=https&sig=eDq4KoQhpGr3h5t1OSPTIAmUxSFMhu87X7SjJ0tsJLg%3D',
      },
    ],
  },
  status: 'succeeded',
};
export const defaultFilter: TrackLocationFilterType = {
  employeeId: '',
  employeeName: '',
  role: DEFAULT_OPTION,
  zone: DEFAULT_OPTION_LOCATION,
  state: DEFAULT_OPTION_LOCATION,
  city: DEFAULT_OPTION_LOCATION,
  district: DEFAULT_OPTION_LOCATION,
  date: new Date(),
  status: { label: 'Logged', value: 'Logged' },
};
export const maxFilesInAdminSettings = {
  welcomeVideos: 6,
  knowledgeCenter: 18,
  banners: 6,
};
export const pdfWorkerUrl =
  'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
export const footerLinks = {
  facebook: 'https://www.facebook.com/KshemaGeneralInsurance/',
  instragram: 'https://www.instagram.com/kshema_general_insurance/',
  linkedin: 'https://www.linkedin.com/company/kshema-general-insurance-limited',
  youtube: 'https://www.youtube.com/@KshemaInsurance',
  termsAndConditions: 'https://kshema.co/terms-and-conditions',
  contactUs: 'https://kshema.co/contact-us/',
};

export const approveReimbursementFilterInit: ApproveReimbursementFilterType = {
  employeeId: '',
  employeeName: '',
  role: DEFAULT_OPTION,
  zone: DEFAULT_OPTION,
  state: DEFAULT_OPTION,
  district: DEFAULT_OPTION,
  city: DEFAULT_OPTION,
  status: DEFAULT_OPTION,
};
export const blankDetailedComplaint = {
  complaintTrackId: '',
  complaintUniqueId: '',
  issueSubject: ' ',
  issueDescription: '',
  customerName: '',
  customerNumber: '',
  customerEmail: '',
  severityId: '',
  severityName: '',
  zone: '',
  zoneName: '',
  state: '',
  stateName: '',
  district: '',
  districtName: '',
  city: '',
  cityName: '',
  pincode: '',
  category: '',
  subCategory: '',
  zohoDeskRefId: '',
  taskReferenceId: '',
  marketingActivityId: '',
  complaintEta: '',
  complaintCompletionOn: '',
  complaintStatus: '',
  complaintStatusName: '',
  createdBy: '',
  createdByFullname: '',
  createdByEmployeeUniqueId: '',
  createdOn: '',
  taskDetails: {
    taskAssignmentId: '',
    taskId: '',
    taskNameId: '',
    taskName: '',
    assignedToId: '',
    assignedToRoleID: '',
    assignedToName: '',
    assignedToCantidateUniqueId: '',
    assignedToEmployeeUniqueId: '',
    assignedToNumber: '',
    assignedToEmailId: '',
    assignedToRoleName: '',
    taskStatus: '',
    taskStatusName: '',
    completedOn: '',
    createdOn: '',
  },
};
export const mediaForTypes = {
  media: 'media',
  thumbnail: 'thumbnail',
};
export const SURVEY_TASK_ID = 10;
export const POSP_ROLE_ID = 7;
